import React from 'react';
import { string, func } from 'prop-types';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { mapTip, mapTipTitle, mapTipText, mapTipClose, tipContainer, mapTipLink } from './styles/styles.module.scss';

const {
  strings: { CLOSE }
} = StringConstantsMixin;

const MapTip = ({ title, text, onClose, linkUrl, linkText }) => {
  const renderLink = () => {
    if (!(linkUrl && linkText)) {
      return null;
    }

    return (
      <a className={mapTipLink} href={linkUrl} target="_blank" rel="noreferrer">
        {linkText}
      </a>
    );
  };

  return (
    <div className={tipContainer}>
      <div className={mapTip}>
        <span className={mapTipTitle}>{title}:</span>
        <span className={mapTipText}>{text}</span>
        {renderLink()}
        <button type="button" label={CLOSE} onClick={e => onClose(e)} className={mapTipClose} />
      </div>
    </div>
  );
};

export default MapTip;

MapTip.propTypes = {
  onClose: func.isRequired,
  title: string.isRequired,
  text: string.isRequired,
  linkUrl: string,
  linkText: string
};

MapTip.defaultProps = {
  linkUrl: null,
  linkText: null
};
